import React from 'react'

export default function ExclamationCircleIcon({
  size = 65,
  fill = '#F2A356',
  className = 'text-[#F2A356]',
  iconFill = 'white',
}) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.334961"
        y="0.46875"
        width="64"
        height="64"
        rx="32"
        fill={fill}
      />
      <g clipPath="url(#clip0_14087_130772)">
        <path
          d="M21.0233 43.782C19.4951 42.3061 18.2762 40.5406 17.4377 38.5885C16.5991 36.6365 16.1577 34.5369 16.1393 32.4125C16.1208 30.288 16.5256 28.1811 17.3301 26.2148C18.1346 24.2484 19.3227 22.462 20.825 20.9597C22.3272 19.4574 24.1137 18.2694 26.08 17.4649C28.0464 16.6604 30.1532 16.2556 32.2777 16.274C34.4022 16.2925 36.5017 16.7339 38.4538 17.5724C40.4058 18.411 42.1713 19.6299 43.6473 21.158C46.5618 24.1757 48.1745 28.2173 48.1381 32.4125C48.1016 36.6076 46.4189 40.6206 43.4524 43.5871C40.4859 46.5537 36.4729 48.2364 32.2777 48.2728C28.0826 48.3093 24.0409 46.6966 21.0233 43.782ZM41.3913 41.526C43.7931 39.1242 45.1424 35.8667 45.1424 32.47C45.1424 29.0734 43.7931 25.8158 41.3913 23.414C38.9895 21.0122 35.7319 19.6629 32.3353 19.6629C28.9386 19.6629 25.6811 21.0122 23.2793 23.414C20.8775 25.8158 19.5282 29.0734 19.5282 32.47C19.5282 35.8667 20.8775 39.1242 23.2793 41.526C25.6811 43.9278 28.9386 45.2772 32.3353 45.2772C35.7319 45.2772 38.9895 43.9278 41.3913 41.526ZM30.7353 34.07V30.87H33.9353V40.47H30.7353V34.07ZM30.7353 24.47H33.9353V27.67H30.7353V24.47Z"
          fill={iconFill}
        />
      </g>
      <defs>
        <clipPath id="clip0_14087_130772">
          <rect
            width="32"
            height="32"
            fill={iconFill}
            transform="translate(16.335 16.4688)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
